import { render, staticRenderFns } from "./goals-page.vue?vue&type=template&id=a3dc17d0&scoped=true"
import script from "./goals-page.vue?vue&type=script&lang=ts"
export * from "./goals-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dc17d0",
  null
  
)

export default component.exports